document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('quick-buy-modal');
  const modalBody = document.getElementById('quick-buy-modal-body');
  const closeBtn = modal?.querySelector('.quick-buy-modal__close');
  const overlay = modal?.querySelector('.quick-buy-modal__overlay');
  
  // Close modal
  function closeModal() {
    modal.classList.add('hidden');
    modalBody.innerHTML = ''; // Clear content
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (overlay) overlay.addEventListener('click', closeModal);

  // Open modal
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-buy-handle]');
    if (!btn) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const handle = btn.dataset.quickBuyHandle;
    
    // Show loading state on button
    btn.classList.add('loading');
    
    try {
      // Fetch product quick buy section
      const response = await fetch(`/products/${handle}?section_id=quick-buy-content`);
      if (!response.ok) throw new Error('Network response was not ok');
      
      const text = await response.text();
      // Extract content from section response (Shopify wraps section responses)
      // Usually it's just the HTML of the section
      
      modalBody.innerHTML = text;
      
      // Initialize form handlers for the new content
      initQuickBuyForm(modalBody);
      
      // Show modal
      modal.classList.remove('hidden');
      
    } catch (error) {
      console.error('Error fetching quick buy:', error);
    } finally {
      btn.classList.remove('loading');
    }
  });
  
  function initQuickBuyForm(container) {
    const form = container.querySelector('form[action="/cart/add"]');
    if (!form) return;
    
    const productScript = container.querySelector('[data-product-json]');
    const product = productScript ? JSON.parse(productScript.textContent) : null;
    
    if (!product) return;

    // Handle Option Changes
    const options = form.querySelectorAll('input[type="radio"], select');
    options.forEach(option => {
      option.addEventListener('change', (e) => {
        // Update Visual Selection
        if (e.target.type === 'radio') {
            const name = e.target.name;
            form.querySelectorAll(`input[name="${name}"]`).forEach(radio => {
                const label = radio.closest('label');
                if (label) label.classList.remove('selected');
            });
            const label = e.target.closest('label');
            if (label) label.classList.add('selected');
        }

        // Gather selected options
        const selectedOptions = Array.from(form.querySelectorAll('input[type="radio"]:checked, select'))
                                     .map(el => el.value);
        
        // Find matching variant
        const variant = product.variants.find(v => {
          return v.options.every((opt, index) => opt === selectedOptions[index]);
        });
        
        // Update UI
        updateQuickBuyUI(container, variant, product);
      });
    });
    
    // Handle Add to Cart
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      const idInput = form.querySelector('input[name="id"]');
      
      if (!idInput.value) return; // No variant selected?
      
      submitBtn.classList.add('loading');
      
      try {
        await addToCart(idInput.value);
        closeModal();
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        submitBtn.classList.remove('loading');
      }
    });
  }
  
  function updateQuickBuyUI(container, variant, product) {
    const priceEl = container.querySelector('.quick-buy-product__price .price');
    const comparePriceEl = container.querySelector('.quick-buy-product__price .compare-price');
    const imageEl = container.querySelector('.quick-buy-product__image');
    const idInput = container.querySelector('input[name="id"]');
    const addBtn = container.querySelector('.quick-buy-product__actions button');
    const btnText = addBtn.querySelector('span');

    if (variant) {
      idInput.value = variant.id;
      priceEl.textContent = formatMoney(variant.price);
      
      if (variant.compare_at_price > variant.price) {
        if (!comparePriceEl) {
             // Create if missing (simplified: assume structure exists or just update priceEl)
             // Ideally we'd toggle visibility
        }
        if(comparePriceEl) comparePriceEl.textContent = formatMoney(variant.compare_at_price);
      } else {
        if(comparePriceEl) comparePriceEl.textContent = '';
      }
      
      // Update Image
      let media = variant.featured_media || variant.featured_image;
      
      // Handle case where media is just an ID (rare but possible in some JSON contexts)
      if (typeof media === 'number' && product.media) {
          media = product.media.find(m => m.id === media);
      }

      // Handle nested preview_image if present (common in newer Shopify APIs)
      if (media && media.preview_image) {
        media = media.preview_image;
      }

      // Fallback to product featured media if variant has no image
      if (!media && product && product.featured_media) {
          media = product.featured_media.preview_image || product.featured_media;
      } else if (!media && product && product.featured_image) {
          media = product.featured_image;
      }

      if (media && (media.src || media.url)) {
        let newSrc = media.src || media.url;
        
        // Handle protocol-relative URLs
        if (newSrc.startsWith('//')) {
            newSrc = 'https:' + newSrc;
        }

        // Shopify Image Resizing Logic
        // Replaces existing size suffix (e.g., _100x) or inserts new one
        if (!newSrc.includes('_600x')) {
            newSrc = newSrc.replace(/(_\d+x)?(\.[^.]*?)(\?v=.*)?$/, '_600x$2$3');
        }
        
        if (imageEl) {
            imageEl.src = newSrc;
            imageEl.removeAttribute('srcset'); // Clear srcset to ensure src is used
        }
      }
      
      if (variant.available) {
        addBtn.removeAttribute('disabled');
        btnText.textContent = "Add to Bag"; // Localization needed?
      } else {
        addBtn.setAttribute('disabled', 'disabled');
        btnText.textContent = "Sold Out";
      }
      
    } else {
      addBtn.setAttribute('disabled', 'disabled');
      btnText.textContent = "Unavailable";
    }
  }

  // Simple formatter - assumes USD or basic formatting. 
  // For proper Shopify formatting, we'd need the currency format string from liquid.
  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
    });
  }

  async function addToCart(id) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    });
    
    if (response.ok) {
       // Refresh Cart logic (reusing from previous step)
       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
       
       const cartDrawer = document.querySelector('cart-drawer');
       if(cartDrawer) {
            fetch('/?section_id=cart-drawer')
            .then(res => res.text())
            .then(text => {
                const newDrawer = new DOMParser().parseFromString(text, 'text/html').querySelector('cart-drawer');
                if(newDrawer && cartDrawer.parentNode) {
                    cartDrawer.replaceWith(newDrawer);
                    // Re-open logic
                     setTimeout(() => {
                         const updatedDrawer = document.querySelector('cart-drawer');
                         if(updatedDrawer) {
                             updatedDrawer.setAttribute('open', '');
                             // Ensure loader is hidden if any
                         }
                    }, 100);
                }
            });
       }
       
       window.dispatchEvent(new CustomEvent('cart-updated'));
    } else {
       throw new Error('Failed to add');
    }
  }
});
